import React from 'react';
import { Calendar, Percent } from 'lucide-react';
import { MULTI_DAY_DISCOUNTS } from '../utils/pricingUtils';

const MultiDayDiscountInfo: React.FC = () => {
  return (
    <div className="bg-green-50 border border-green-200 rounded-none p-4 mb-6">
      <div className="flex items-start">
        <Percent className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" />
        <div>
          <h3 className="font-medium text-green-800 mb-2">Flerdagsrabatt</h3>
          <p className="text-green-700 text-sm mb-3">
            Ju längre du hyr, desto mer sparar du! Rabatt från dag 2: 20 %, från dag 3: 30 %, från dag 5: 50 % (gäller varje dag i perioden).
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
            {MULTI_DAY_DISCOUNTS.map((discount, index) => (
              <div 
                key={index}
                className={`text-center p-2 rounded ${
                  discount.discountPercentage > 0 
                    ? 'bg-green-100 border border-green-300' 
                    : 'bg-gray-100 border border-gray-300'
                }`}
              >
                <div className="font-medium text-sm">
                  {discount.label}
                </div>
                <div className={`text-xs ${
                  discount.discountPercentage > 0 ? 'text-green-700' : 'text-gray-600'
                }`}>
                  {discount.discountPercentage > 0 
                    ? `-${discount.discountPercentage}%` 
                    : 'Ordinarie pris'
                  }
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultiDayDiscountInfo;